import { useCurrentUser } from '@/entities/user/currentUser';

import { CONTENT } from '../lib/limitedFeatures';
import { LimitedFeature, PLAN_CATEGORIES, PlanCategoriesKeys } from '../lib/types';
import { useProducts } from './useProducts';

export const useUpgradePlanModalContent = (limitedFeature: LimitedFeature, plan?: PlanCategoriesKeys) => {
  const { products } = useProducts(true);

  const { data: user } = useCurrentUser();

  const userPlanCategory =
    plan ?? products?.plan.find((p) => p.id === user?.subscription?.plan.product_id)?.category ?? 'trial';

  const planCategory = PLAN_CATEGORIES[userPlanCategory];

  return {
    content: CONTENT[limitedFeature][planCategory] ?? CONTENT[limitedFeature]['trial'],
    planCategory,
  };
};
